// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MNa6","title":"styles_title__1aXmv"};